import { Button, Divider, IconButton, Typography } from "@mui/material";
import { useSelector } from "react-redux";

export const CheckoutSummery = ({
  items,
  checkoutData,
  dispatch,
  enableDelivery = false,
  orderDet,
  currency,
}) => {
  return (
    <div style={{ padding: "0.6rem", marginLeft: "1rem" }}>
      <div style={{ marginBlock: "1rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "0.3rem",
          }}
        >
          <Typography>
            Subtotal ({items?.length} {items?.length === 1 ? "item" : "items"})
          </Typography>
          <Typography fontWeight="bold">
            {currency.currencySymbol}{" "}
            {(parseFloat(orderDet?.totAmt || 0) * currency.currencyRate).toFixed(2)}
          </Typography>
        </div>
        {orderDet?.totTax !== 0 && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "0.3rem",
              }}
            >
              <Typography>Total Tax</Typography>
              <Typography fontWeight="bold">
                {currency.currencySymbol}{" "}
                {(parseFloat(orderDet?.totTax || 0) * currency.currencyRate).toFixed(2)}
              </Typography>
            </div>
            {orderDet?.taxDetails?.map((tax) => (
              <div
                key={tax.taxId}
                style={{
                  display: "flex",
                  width: "70%",
                  marginLeft: "3rem",
                  justifyContent: "space-between",
                  marginBottom: "0.3rem",
                }}
              >
                <Typography>{tax.tax}</Typography>
                <Typography>
                  {currency.currencySymbol} {(parseFloat(tax.taxAmt) * currency.currencyRate).toFixed(2)}
                </Typography>
              </div>
            ))}
          </div>
        )}
        {checkoutData?.totOff && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "0.3rem",
            }}
          >
            <Typography>Total Offer</Typography>
            <Typography fontWeight="bold">
              ({currency.currencySymbol}{" "}
              {(parseFloat(orderDet?.totOff || 0) * currency.currencyRate).toFixed(2)})
            </Typography>
          </div>
        )}
        {(orderDet?.coupon || checkoutData?.totOff) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "0.3rem",
            }}
          >
            {/* Additional content can go here if needed */}
          </div>
        )}
        {orderDet?.totChg !== 0 && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Total Charge</Typography>
              <Typography fontWeight="bold">
                {currency.currencySymbol}{" "}
                {(parseFloat(orderDet?.totChg || 0) * currency.currencyRate).toFixed(2)}
              </Typography>
            </div>
            {orderDet?.chargeDetails?.map((chg) => (
              <div
                key={chg.chargeId}
                style={{
                  display: "flex",
                  width: "70%",
                  marginLeft: "3rem",
                  justifyContent: "space-between",
                  marginBottom: "0.3rem",
                }}
              >
                <Typography>{chg.charge}</Typography>
                <Typography>
                  {currency.currencySymbol}{" "}
                  {(parseFloat(chg.chargeAmt) * currency.currencyRate).toFixed(2)}
                </Typography>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export const CheckoutTotal = ({ orderDet, totWithOff, delivery, currency }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      paddingInline: "0.5rem",
      paddingBlock: "0.5rem",
      marginLeft: "1rem",
    }}
  >
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" fontWeight="bold" style={{ fontSize: "1.2rem" }}>
        Total Payment
      </Typography>
      <Typography variant="body1" style={{ fontSize: "1rem" }}>
        (Inclusive VAT)
      </Typography>
    </div>
    {totWithOff ? (
      <Typography
      variant="h6"
      fontWeight="bold"
      color="primary"
      style={{
        fontSize: "1.2rem",
        textAlign: "right", // Add textAlign here
        marginLeft: "auto", // Add marginLeft: auto to align to the right
      }}
    >
      {currency.currencySymbol} {(totWithOff * currency.currencyRate).toFixed(2)}
    </Typography>
    ) : (
      <Typography
      variant="h6"
      fontWeight="bold"
      color="primary"
      style={{
        fontSize: "1.2rem",
        textAlign: "right", // Add textAlign here
        marginLeft: "auto", // Add marginLeft: auto to align to the right
      }}
    >
      {currency.currencySymbol}{" "}
      {(parseFloat(orderDet?.totPay + delivery || orderDet?.totPay || 0) * currency.currencyRate).toFixed(2)}
    </Typography>
    
    )}
  </div>
);

const PaymentSummery = ({ items, orderDet, cartId }) => {
  const currency = useSelector((state) => state.currency);

  return (
    <>
      <CheckoutSummery
        items={items}
        disableCoupon
        orderDet={orderDet}
        currency={currency}
      />
      <CheckoutTotal orderDet={orderDet} currency={currency} />
    </>
  );
};

export default PaymentSummery;
